import styled from 'styled-components'

export const APIKeyButton = styled.button`
  background: transparent;
  border: none;
  text-decoration: underline;
  color: ${props => props.theme.colors.secondary};
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  span + & {
    margin-left: 16px;
  }
`

export const APIKeyText = styled.p`
  border-radius: 8px;
  background-color: rgba(219, 219, 219, 0.2);
  width: 100%;
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 800;
  padding: 8px 14px;
  margin-top: 16px;
`

export const ModalCloseButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`
